import { Snackbar } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "@app/hooks/useAppDispatch";
import { hideToast, selectToast } from "@app/redux/toastSlice";
import { SuccessToast } from "@app/components/SuccessToast";
import { ErrorToast } from "@app/components/ErrorToast";

export const AppToast = React.memo(() => {
  const toast = useAppSelector(selectToast);
  const dispatch = useDispatch();
  const handleClose = (
    event?: React.SyntheticEvent<any> | Event,
    reason?: string,
  ) => {
    if (reason !== "clickaway") {
      dispatch(hideToast());
    }
  };

  return (
    <Snackbar
      open={toast.open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={toast.anchorOrigin}
    >
      {toast.kind === "errorMessage" ? (
        <ErrorToast onClose={handleClose} title={toast.title ?? "Error"}>
          {toast.message}
        </ErrorToast>
      ) : (
        <SuccessToast onClose={handleClose} kind={toast.kind}>
          {toast.message}
        </SuccessToast>
      )}
    </Snackbar>
  );
});
